import React from 'react'
import classnames from "classnames";
import * as cl from './Preloader.module.scss'

export function Preloader({className, isSmall}) {
  return (
    <div className={classnames(cl.ring, className, {[cl.small]: isSmall})}>
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  );
}
